// AlertManager.jsx

import ProtectedGrafanaFrame from "./components/ProtectedGrafanaFrame";

const AlertManager = () => {
  const grafanaAlertDashboardUrl = "/grafana/alerting/list?kiosk";

  return (
    <ProtectedGrafanaFrame
      src={grafanaAlertDashboardUrl}
      title="Alert Manager Dashboard"
      sx={{
        height: `calc(100vh - ${60}px)`,
      }}
    />
  );
};

export default AlertManager;
